export default __webpack_public_path__ + "images/V3.2d34c11.png";